var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTop10 = function SvgTop10(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D96FF",
    d: "M10.29 12.332h2.451a.23.23 0 0 0 .166-.065.23.23 0 0 0 .065-.166V5.899a.23.23 0 0 0-.065-.166.23.23 0 0 0-.166-.065h-2.452a.23.23 0 0 0-.166.065.23.23 0 0 0-.065.166V12.1q0 .1.065.166a.23.23 0 0 0 .166.065m0 1.586q-.764 0-1.292-.526a1.76 1.76 0 0 1-.526-1.291V5.899q0-.765.526-1.291a1.76 1.76 0 0 1 1.291-.526h2.452q.765 0 1.29.526.527.526.527 1.29v6.203q0 .765-.526 1.29a1.76 1.76 0 0 1-1.291.527zm-5.193-8.25h-.859a.77.77 0 0 1-.562-.23.77.77 0 0 1-.23-.563q0-.332.23-.563a.77.77 0 0 1 .562-.23h1.767q.29 0 .484.194.194.193.194.484v8.365a.77.77 0 0 1-.23.562.77.77 0 0 1-.563.231.77.77 0 0 1-.563-.23.77.77 0 0 1-.23-.563z"
  }))));
};
export default SvgTop10;